var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ubiHeaderPage disFlex" }, [
    _c(
      "div",
      { staticClass: "mainCont", class: { device: _vm.device === "mobile" } },
      [
        _c("div", { staticClass: "leftCont" }, [
          _c(
            "div",
            { staticClass: "menu-list" },
            [
              _c("div", { staticClass: "menu-box-1" }, [
                _c("div", { staticClass: "menu-title-1" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.ubismartparcel.com",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ubi.home")))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.ubiMenuList, function (parent) {
                return _c(
                  "div",
                  {
                    key: parent.moduleUUID,
                    staticClass: "menu-box-1",
                    attrs: { index: parent.moduleUUID },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "menu-title-1 custom-letter-space" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(parent.resourceKey) +
                            "\n            "
                        ),
                        _c("i", { staticClass: "el-icon-arrow-down" }),
                      ]
                    ),
                    _vm._v(" "),
                    parent.children && parent.children.length > 0
                      ? [
                          _c("el-collapse-transition", [
                            _c("div", { staticClass: "menu-box-2" }, [
                              _c(
                                "div",
                                { staticClass: "menu-box-2-title-list" },
                                _vm._l(parent.children, function (child) {
                                  return _c(
                                    "div",
                                    {
                                      key: child.moduleUUID,
                                      staticClass: "menu-title-2",
                                      attrs: { index: child.path },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleSelectMenu(
                                            parent.path,
                                            child.path,
                                            parent.titleEn
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(child.resourceKey))]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rightCont" }, [
          _c(
            "div",
            { staticClass: "right-menu" },
            [
              !_vm.name
                ? _c(
                    "div",
                    { staticClass: "login-btn", on: { click: _vm.loginBtn } },
                    [_vm._v(_vm._s(_vm.$t("common.login2")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              !!_vm.name
                ? _c("div", { staticClass: "menu-list" }, [
                    _c(
                      "div",
                      { staticClass: "menu-box-1" },
                      [
                        _c("div", { staticClass: "menu-title-1" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.name) +
                              "\n              "
                          ),
                          _c("i", { staticClass: "el-icon-caret-bottom" }),
                        ]),
                        _vm._v(" "),
                        _c("el-collapse-transition", [
                          _c("div", { staticClass: "menu-box-2" }, [
                            _c(
                              "div",
                              {
                                staticClass: "menu-box-2-title-list logout-box",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu-title-2",
                                    on: { click: _vm.logout },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("ubi.logOut")))]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("lang-select", { staticClass: "right-menu-item" }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }